"use strict";

exports.__esModule = true;
exports.unformatter = void 0;
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _Catalogs = require("../../../../Catalogs");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var findKeyByValue = function findKeyByValue(object, value) {
  var key = Object.keys(object).find(function (key) {
    return object[key] === value;
  });
  return key ? key : value;
};
var unformatter = exports.unformatter = function unformatter(columnType, value, contexts) {
  var devices = contexts.devices,
    plantStateActivities = contexts.plantStateActivities;
  var devicesMap = devices.reduce(function (acc, device) {
    acc[device.uuid] = device.name;
    return acc;
  }, {});
  var statesMap = plantStateActivities.states.reduce(function (acc, state) {
    acc[state.id] = state.name;
    return acc;
  }, {});
  var activitiesMap = plantStateActivities.activities.reduce(function (acc, activity) {
    acc[activity.id] = activity.name;
    return acc;
  }, {});
  var metricDefinitionsFastFind = _Catalogs.metricDefinitions.reduce(function (acc, metric) {
    acc[metric.name] = metric.label;
    return acc;
  }, {});
  switch (columnType) {
    case "deviceName":
      return findKeyByValue(devicesMap, value);
    case "state":
      return findKeyByValue(statesMap, value);
    case "activity":
      return findKeyByValue(activitiesMap, value);
    case "metric":
      return findKeyByValue(metricDefinitionsFastFind, value);
    case "hour":
      return (0, _momentTimezone["default"])(value, "h:mm").format("h");
    default:
      return value;
  }
};